import Image from 'next/image'
import { Box, Typography, Button, useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { string } from 'prop-types'

export default function PdfIframe({ title, pdf, testId = 'PdfIframe' }) {
  const pdfUrl = pdf?.startsWith('//') ? pdf?.substring(2) : pdf
  // const url = 'https://docs.google.com/gview?embedded=true&url=' + pdfUrl
  const cacheBustedUrl = pdfUrl + `?t=${new Date().getTime()}`

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Box
      sx={{
        minHeight: '800px',
        width: '100%',
        bgcolor: 'grey.extraLight',
      }}
      data-testid={testId}
    >
      <Box
        mt={5}
        px={3}
        display='flex'
        justifyContent='space-between'
        alignItems='center'
        sx={{
          width: '100%',
          height: '76px',
          bgcolor: 'primary.main',
          color: 'common.white',
        }}
      >
        <Box data-testid={`${testId}-title`}>
          <Typography variant='subtitle1'>{title}</Typography>
        </Box>
        <Button
          variant='contained'
          color='secondary'
          onClick={() => window.open(pdfUrl, '_blank')}
          endIcon={
            !isMobile && (
              <Image
                src={'/images/popout.svg'}
                alt='Popout Icon'
                width={18}
                height={18}
                layout='fixed'
              />
            )
          }
          sx={{
            bgcolor: 'common.white',
            color: 'common.black',
            width: { xs: '24px', sm: 'auto' },
            height: { xs: '24px', sm: 'auto' },
          }}
        >
          {isMobile ? (
            <Image
              src={'/images/popout.svg'}
              alt='Popout Icon'
              width={22}
              height={22}
              layout='fixed'
            />
          ) : (
            'Pop-Out'
          )}
        </Button>
      </Box>
      <Box data-testid={`${testId}-pdf`}>
        <Box
          component='iframe'
          sx={{
            minHeight: '800px',
            width: '100%',
            backgroundColor: 'grey.extraLight',
          }}
          src={cacheBustedUrl}
          aria-label={'pdf iframe'}
        />
      </Box>
    </Box>
  )
}

PdfIframe.propTypes = {
  title: string,
  pdf: string,
  testId: string,
}
